import { axiosInstance } from "@/axios/interceptors";

export type VerifyEmailPayload = {
	token: string;
};

export const verifyEmail = async (payload: VerifyEmailPayload) => {
	const response = await axiosInstance.get("/guests/verify_email", {
		headers: {
			Authorization: `Bearer ${payload.token}`,
		},
	});
	return response.data;
};
